import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { splitListItems } from "@/lib/utils";
import { ClipboardList } from "lucide-react";

export default function MyResponsibilities() {
  const { data, isLoading } = useQuery({ queryKey: ["myResp"], queryFn: async () => (await api.get("/my/responsibilities")).data });
  if (isLoading) return <Loading />;
  return (
    <div>
      <PageHeader overline="My Role" title="My Job Responsibilities" icon={ClipboardList}
        subtitle="Your current responsibilities as assigned by HR." />
      {(data || []).length === 0 ? (
        <EmptyState icon={ClipboardList} title="No responsibilities assigned yet" hint="Your HR team will assign responsibilities to your profile." />
      ) : (
        <Card className="p-6 border-slate-200 shadow-none">
          <ul className="space-y-3" data-testid="my-responsibilities">
            {data.map((r) => {
              const items = splitListItems(r.text);
              return (
                <li key={r.id} className="flex items-start gap-3">
                  <span className="h-2 w-2 rounded-full bg-teal mt-2 shrink-0" />
                  <div>
                    {items.length > 1 ? (
                      <ul className="space-y-1">
                        {items.map((item, i) => (
                          <li key={i} className="text-sm text-navy flex items-start gap-2">
                            <span className="h-1 w-1 rounded-full bg-teal/60 mt-1.5 shrink-0" />{item}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-sm text-navy">{r.text}</p>
                    )}
                    <p className="text-xs text-slate-400 mt-0.5">Effective from {r.effective_from?.slice(0, 10) || "—"}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </Card>
      )}
    </div>
  );
}
